import React, { useEffect, useState } from 'react';
// import { useHistory } from "react-router-dom";
// import Stack from '@mui/material/Stack';
// import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import Paper from '@mui/material/Paper';
import { Card } from '@material-ui/core';
import http from '../../services/http-service';
import { toast } from 'react-toastify';

// const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     color: theme.palette.text.secondary,
// }));

function DisbursementsDetail(props) {
    // debugger
    // const history = useHistory();
    const [open, setOpen] = useState(false);
    const [withdrawals, setWithdrawals] = useState([]);
    const [pendingData, setPendingData] = useState([]);
    // }

    useEffect(() => {
        fetchPendingData()
        fetchSuccessData()
        // fetchEmployeeData(currentPage, searchItem);
        // eslint-disable-next-line
    }, []);

    // const handlePageChange = (event, page) => {
    //     history.push('/users-list/' + page);
    // }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const fetchPendingData = () => {

        handleToggle()
        let params = {
            "user_id": props.userId
        }
        http('employee/payment/disbarment/pending', 'GET', '', params)
            .then(res => {
                if (res.status) {
                    console.log('res.data.results[0]......', res.data.results)
                    setPendingData(res.data.results);
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId1"
                    })
                }

                handleClose()
            },
                err => {
                    console.log('err....', err)
                    handleClose()
                });
    }

    const fetchSuccessData = () => {
        handleToggle()
        let params = {
            "user_id": props.userId,
            "type": "success"
        }
        http('employee/payment/disbarment', 'GET', '', params)
            .then(res => {
                if (res.status) {
                    setWithdrawals(res.data.results);
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId1"
                    })
                }

                handleClose()
            },
                err => {
                    console.log('err....', err)
                    handleClose()
                });
    }

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={false}

            >
                <CircularProgress color="inherit" />
            </Backdrop>


            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <Card elevation={3} className="cardBox">
                        <Typography className="disbursmentTitle">Withdrawals</Typography>
                        <Box className='transactionBox'>
                        {
                            withdrawals.length > 0 ? (
                                <>
                                    {
                                        withdrawals.map((data) => (
                                            <item className="itemList">
                                                <Box className="flexGrid">
                                                    <Typography className="dateText"> {data.transfer_date} </Typography>
                                                    <Typography className="dateText"> {data.payment_type} </Typography>
                                                </Box>
                                                <Typography className="recievedText"> You received: <span className="currencyText">N</span>{data.amt_receive} + <span className="currencyText"></span> {data.transaction_fees} fee</Typography>
                                            </item>
                                        ))
                                    }
                                </>

                            ) : (
                                <div className='recordNotFoundDiv'>
                                    <h2>Records Not Found</h2>
                                </div >
                            )

                        }
                        </Box>
                        {/* <item className="itemList">
                            <Box className="flexGrid">
                                <Typography className="dateText"> Mon 10 May 21 </Typography>
                                <Typography className="acceptedText"> Accepeted </Typography>
                            </Box>
                            <Typography className="recievedText"> You received: <span className="currencyText">N</span> 1249.20 + <span className="currencyText">N</span> 0.80 fee</Typography>
                        </item>

                        <item className="itemList">
                            <Box className="flexGrid">
                                <Typography className="dateText"> Mon 10 May 21 </Typography>
                                <Typography className="acceptedText"> Accepeted </Typography>
                            </Box>
                            <Typography className="recievedText"> You received: <span className="currencyText">N</span> 1249.20 + <span className="currencyText">N</span> 0.80 fee</Typography>
                        </item>

                        <item className="itemList">
                            <Box className="flexGrid">
                                <Typography className="dateText"> Mon 10 May 21 </Typography>
                                <Typography className="acceptedText"> Accepeted </Typography>
                            </Box>
                            <Typography className="recievedText"> You received: <span className="currencyText">N</span> 1249.20 + <span className="currencyText">N</span> 0.80 fee</Typography>
                        </item> */}
                    </Card>

                    <Card elevation={3} className="cardBox">
                        <Typography className="disbursmentTitle">Pending transactions</Typography>

                        <Box className='transactionBox'>
                        {
                            pendingData.length > 0 ? (
                                <>
                                    {
                                        pendingData.map((data) => (
                                            <item className="itemList">
                                                <Box className="flexGrid">
                                                    <Typography className="dateText"> {data.transfer_date} </Typography>
                                                    <Typography className="dateText"> {data.payment_type} </Typography>
                                                </Box>
                                                <Typography className="recievedText"> You received: <span className="currencyText">N</span>{data.amt_receive} + <span className="currencyText">N</span>{data.transaction_fees} fee</Typography>
                                            </item>
                                        ))
                                    }
                                </>

                            ) : (
                                <div className='recordNotFoundDiv'>
                                    <h2>Records Not Found</h2>
                                </div >
                            )
                        }
                        </Box>
                        {/* <item className="itemList">
                            <Box className="flexGrid">
                                <Typography className="dateText"> Mon 10 May 21 </Typography>
                                <Typography className="dateText"> Pending </Typography>
                            </Box>
                            <Typography className="recievedText"> You received: <span className="currencyText">N</span> 1249.20 + <span className="currencyText">N</span> 0.80 fee</Typography>
                        </item>

                        <item className="itemList">
                            <Box className="flexGrid">
                                <Typography className="dateText"> Mon 10 May 21 </Typography>
                                <Typography className="dateText"> Pending </Typography>
                            </Box>
                            <Typography className="recievedText"> You received: <span className="currencyText">N</span> 1249.20 + <span className="currencyText">N</span> 0.80 fee</Typography>
                        </item>

                        <item className="itemList">
                            <Box className="flexGrid">
                                <Typography className="dateText"> Mon 10 May 21 </Typography>
                                <Typography className="dateText"> Pending </Typography>
                            </Box>
                            <Typography className="recievedText"> You received: <span className="currencyText">N</span> 1249.20 + <span className="currencyText">N</span> 0.80 fee</Typography>
                        </item> */}
                    </Card>
                </Grid>
            </Grid>


            {/* {
                tableData.length > 0 ? */}
            {/* <div>
                <div className='customTable'>
                    <table>
                        <thead>
                            <tr>
                                <th>View</th>
                                <th>Start Balance</th>
                                <th>Money out</th>
                                <th>Money in</th>
                                <th>End Balance</th>
                                <th>Period Start Date</th>
                                <th>Period End Date</th>
                            </tr>
                        </thead>
                        <tbody> */}

            {/* {tableData.map((data, index) => ( */}
            {/* <tr>
                                <td></td>
                                <td>00.00</td>
                                <td>12000.50</td>
                                <td>12000.50</td>
                                <td>00.00</td>
                                <td>01/09/2022</td>
                                <td>30/09/2022</td>
                            </tr> */}
            {/* ))} */}


            {/* </tbody>
                    </table>
                </div> */}

            {/* <Stack spacing={2} className="employeePagination">
                <Pagination count={1} page={1} color="primary" />
            </Stack> */}
            {/* </div> */}
            {/* :
                    <div className='recordNotFoundDiv'>
                        <h2>Records Not Found</h2>
                    </div>
            } */}
        </div>
    )

}
export default DisbursementsDetail;